<template>
  <div v-loading="loading">
    <div ref="tablePrint" class="print">
      <div style="margin-top: 10px; height: 650px; overflow: auto">
        <div id="tablePrint">
          <companySumTable :tabelTitel="tabelTitel" :listQuery="listQuery" :tabelList="tabelList" :sumsTotal="sumsTotal"></companySumTable>
        </div>
      </div>
    </div>
    <div ref="tablePrintExport" class="Export_table" v-show="false">
      <div style="margin-top: 10px; height: 650px; overflow: auto">
        <div id="tablePrintExport">
          <companySumTable :tabelTitel="tabelTitel" :listQuery="listQuery" :exportShow="true" :tabelList="tabelList" :sumsTotal="sumsTotal"></companySumTable>
        </div>
      </div>
    </div>
    <div id="copy_div" v-show="false" style="'width:100%'" class="'flex-seting'"></div>
  </div>
</template>
<script>
import DateUtils from '@/utils/DateUtils';
import companySumTable from './companySumTable.vue';
import getLodop from '../../utils/Lodopfuncs';

export default {
  components: {
    companySumTable,
  },
  data() {
    return {
      listQuery: {
        businessDate: DateUtils.formatDate(new Date(), 'yyyy-MM-dd '),
        setMealIds: [],
      },
      hotelInfo: localStorage.getItem('hotelInfo'),
      loading: false,
      tabelTitel: [
        {
          code: '',
          chinese_desc: '序号',
        },
        {
          code: 'business_date',
          chinese_desc: '日期',
        },
        {
          code: 'name',
          chinese_desc: '单位名称',
        },
        {
          code: 'c1',
          chinese_desc: '早餐次数',
        },
        {
          code: 'totalPrice1',
          chinese_desc: '早餐核销金额',
        },
        {
          code: 'payTotal1',
          chinese_desc: '早餐自费',
        },
        {
          code: 'c2',
          chinese_desc: '午餐次数',
        },
        {
          code: 'totalPrice2',
          chinese_desc: '午餐核销金额',
        },
        {
          code: 'payTotal2',
          chinese_desc: '午餐自费',
        },
        {
          code: 'c3',
          chinese_desc: '晚餐次数',
        },
        {
          code: 'totalPrice3',
          chinese_desc: '晚餐核销金额',
        },
        {
          code: 'payTotal3',
          chinese_desc: '晚餐自费',
        },
        {
          code: 'accountTotal',
          chinese_desc: '累计就餐人数',
        },
        {
          code: 'totalPrice',
          chinese_desc: '累计核销金额',
        },
        {
          code: 'payTotal',
          chinese_desc: '总自费',
        },
      ],
      tabelList: [],
    };
  },
  created() {
    this.getInit();
    this.$bus.$on('todoQuery', this.getData);
    this.$bus.$on('todoPrintCatering', this.todoPrint);
    this.$bus.$on('todoExportCatering', this.todoExport);
  },
  beforeDestroy() {
    this.$bus.$off('todoQuery', this.getData);
    this.$bus.$off('todoPrintCatering', this.todoPrint);
    this.$bus.$off('todoExportCatering', this.todoExport);
  },
  computed: {
    sumsTotal: function () {
      let sums = [];
      this.tabelTitel.map((item, index) => {
        this.tabelList.map(sItem => {
          if (['c1', 'totalPrice1', 'c2', 'totalPrice2', 'c3', 'totalPrice3', 'accountTotal', 'totalPrice', 'payTotal1', 'payTotal2', 'payTotal3', 'payTotal'].includes(item.code)) {
            if (!sums[index]) {
              sums[index] = 0;
            }
            if (sItem[item.code]) {
              sums[index] = Number(sums[index]) + Number(sItem[item.code]);
            }
            sums[index] = sums[index] + '';
          }
        });
      });
      if (this.tabelTitel.length) {
        sums[0] = '合计';
      }
      return sums;
    },
  },
  methods: {
    getData(val) {
      this.listQuery = Object.assign({}, val);
      this.getInit();
    },
    getInit() {
      let data = this.listQuery;
      this.$axios({
        methods: 'get',
        url: this.api.kcCorpWriteOffTotal,
        data,
      }).then(res => {
        if (res.data.status == 0) {
          this.tabelList = res.data.data || [];
        }
      });
    },
    todoPrint(type) {
      const LODOP = getLodop();
      // 获取大小和宽度
      let printSize = this.$store.state.user?.printSize ? this.$store.state.user?.printSize : 12;
      let width = this.$store.state.user?.printWidth ? this.$store.state.user?.printWidth : 2;
      if (LODOP) {
        // 判断是否是数字
        let falg = false;
        if (document.getElementById('tablePrint')) {
          document.getElementById('copy_div').innerHTML = '';
          let innerHTML = document.getElementById('tablePrint').cloneNode(true);
          innerHTML.style.border = 'none';
          innerHTML.style.borderCollapse = 'collapse';
          innerHTML.style.fontSize = printSize + 'px';
          document.getElementById('copy_div').appendChild(innerHTML);
          falg = true;
        }
        this.$nextTick(() => {
          var strFormHtml =
            `
                <body >` +
            document.getElementById(falg ? 'copy_div' : 'tablePrint').innerHTML +
            '</body>'; //获取打印内容
          LODOP.PRINT_INIT(''); //初始化
          LODOP.SET_PRINT_PAGESIZE(0, 0, 0, 'A4'); //设置打印方向
          LODOP.ADD_PRINT_TABLE('2%', width + '%', 100 - width * 2 + '%', '88%', strFormHtml);
          LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -100);
          LODOP.SET_PRINT_STYLEA(0, 'LetterSpacing', 0);
          LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, ''); //设置预览窗口模式和大小
          LODOP.ADD_PRINT_TEXT(566, 542, 165, 22, '第#页/共&页');
          LODOP.SET_PRINT_STYLEA(0, 'ItemType', 2);
          LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
          LODOP.SET_PRINT_STYLEA(0, 'Vorient', 1);
          if (type === 'preview') {
            LODOP.PREVIEW();
          } else {
            LODOP.PRINT();
          }
        });
      }
    },
    todoExport() {
      const LODOP = getLodop();
      if (LODOP) {
        // 获取大小和宽度
        let width = 2;
        var strFormHtml = '<body>' + document.getElementById('tablePrintExport').innerHTML + '</body>'; //获取打印内容
        LODOP.PRINT_INIT(''); //初始化
        LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4'); //设置纵向
        LODOP.ADD_PRINT_TABLE('2%', width + '%', 100 - width * 2 + '%', '88%', strFormHtml);
        LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -100);
        LODOP.SAVE_TO_FILE('单位核销统计汇总.xlsx');
      }
    },
  },
};
</script>
